import { render, staticRenderFns } from "./coach-credit-tab.vue?vue&type=template&id=4afa0bbd"
import script from "./coach-credit-tab.vue?vue&type=script&lang=js"
export * from "./coach-credit-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports